var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.36 22.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#252529;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.68,14.53c-1.12,0-2.23,0-3.35,0-3.22.01-5.68,2.44-5.73,5.67,0,.63.01,1.26,0,1.89-.02.62-.53.99-1.06.79-.29-.11-.49-.33-.5-.64-.04-1.63-.13-3.25.52-4.81,1.11-2.67,3.71-4.45,6.6-4.47,2.3-.02,4.61,0,6.92,0,4.03.01,7.14,3.07,7.28,7.15.02.68.02,1.35,0,2.03-.01.41-.23.66-.58.76-.35.1-.65-.02-.84-.31-.11-.17-.15-.4-.15-.61-.02-.56,0-1.12,0-1.68-.03-3.33-2.48-5.77-5.8-5.78-1.09,0-2.19,0-3.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.37,5.7c.01,3.09-2.56,5.68-5.66,5.69-3.13.01-5.72-2.55-5.72-5.66C4.98,2.57,7.53.01,10.68,0c3.12-.01,5.68,2.55,5.69,5.7Zm-1.58.03c.04-2.22-1.79-4.09-4.04-4.14-2.26-.05-4.15,1.78-4.19,4.06-.04,2.26,1.8,4.13,4.09,4.16,2.24.03,4.09-1.8,4.13-4.08Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/my_account.9044b7e06be9a8faec7084ad37729954.svg";
export { ForwardRef as ReactComponent };